import { toast } from 'sonner'
import { formatDay, money, shortDay, type PerkItem } from '@/lib/perks'
import { errorMessage, perksApi, usePerksMutation } from '@/lib/perksApi'

/** Mark used / skip, shared by rows and the benefit dialog. */
export function useBenefitActions() {
  const mutate = usePerksMutation()
  return {
    markUsed: async (item: PerkItem) => {
      try {
        await mutate(() => perksApi.logUse(item.benefit.id, { amount_cents: item.status.remainingCents, date: formatDay(new Date()) }))
        toast.success(item.benefit.kind === 'certificate' ? `${item.benefit.name} marked as used` : `Logged ${money(item.status.remainingCents)} of ${item.benefit.name}`)
      } catch (e) {
        toast.error(errorMessage(e))
      }
    },
    skip: async (item: PerkItem) => {
      try {
        await mutate(() => perksApi.logUse(item.benefit.id, { amount_cents: 0, date: formatDay(new Date()), is_skip: true }))
        toast.success(`Skipped until ${shortDay(item.status.period.end)}`)
      } catch (e) {
        toast.error(errorMessage(e))
      }
    },
  }
}

